import React, { useEffect, useState } from 'react';

import { Grid, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { IAward, TStandingType } from '../../../../../../store/admin/eventAwards/store';

import { AutoComplete } from '../../../../../../components/AutoComplete/AutoComplete';
import Button from '../../../../../../components/Button';
import { DollarInputAdornment } from '../../../../../../components/DollarInputAdornment/DollarInputAdornment';
import Input from '../../../../../../components/Input';
import { IOption } from '../../../../../../components/Select/Select';
import { EditableTableCell } from '../../../../Common/EditableTableCell/EditableTableCell';
import { standingTypes } from '../../../../Standings/Standings';
import { IOnAwardChange } from '../AssignAwardsTable';

const awardTypeOptions = [
  { label: 'Event Finish', value: 'Event Finish' },
  { label: 'Long Drive', value: 'Long Drive' },
  { label: 'Closest To Pin', value: 'Closest To Pin' },
  { label: 'Skins', value: 'Skins' },
  { label: 'Horse Race', value: 'Horse Race' },
  { label: 'Played-In', value: 'Played-In' }
];

interface IAwardRowFields {
  award: IAward;
  newAward: IAward;
  editMode: boolean;
  onAwardChange: IOnAwardChange;
  onToggleEditMode: () => void;
  playersOptions: IOption[];
}

export const AwardRowFields = (props: IAwardRowFields) => {
  const { newAward, award, onAwardChange, playersOptions, editMode, onToggleEditMode } = props;

  const defaultTouchFields = {
    cash: false,
    note: false,
    points: false,
    scrip: false
  };

  const [touchedFields, setTouchedFields] = useState(defaultTouchFields);

  useEffect(() => {
    setTouchedFields(defaultTouchFields);
  }, [editMode]);

  const isStandingType = (item: any): item is TStandingType =>
    standingTypes.includes(item as TStandingType);

  const isInvalidStandingTypeField = (attribute: string, event: any) =>
    isStandingType(attribute) &&
    event &&
    event.target &&
    event.target.value &&
    isNaN(parseInt(event.target.value, undefined));

  const onFieldChange = (attribute: string) => (event: any) => {
    if (!isInvalidStandingTypeField(attribute, event)) {
      setTouchedFields({ ...touchedFields, [attribute]: true });
      onAwardChange(attribute)(event);
    }
  };

  const { type, points, user, cash, scrip, note } = {
    cash: editMode && touchedFields.cash ? newAward.cash : award.cash,
    note: editMode && touchedFields.note ? newAward.note : award.note,
    points: editMode && touchedFields.points ? newAward.points : award.points,
    scrip: editMode && touchedFields.scrip ? newAward.scrip : award.scrip,
    type: editMode && newAward.type ? newAward.type : award.type,
    user: editMode && newAward.user > 0 ? newAward.user : award.user
  };

  const rowPlayerOption = playersOptions.find(
    (playerOption: IOption) => playerOption.value === String(user)
  );

  const awardTypeOption = awardTypeOptions.find(
    (typeOption: IOption) => typeOption.value === String(type)
  );

  const { label: playerName } = rowPlayerOption ? rowPlayerOption : { label: '' };

  return (
    <TableRow key={`${award.id}`} className={editMode ? 'editable-row-fields' : ''}>
      <TableCell style={editMode ? { paddingTop: '30px' } : undefined}>
        {editMode ? (
          <AutoComplete
            value={rowPlayerOption}
            placeholder="Select Player"
            className="select-autocomplete"
            options={playersOptions}
            onChange={onAwardChange('user')}
            isClearable={true}
          />
        ) : (
          playerName
        )}
      </TableCell>
      <TableCell style={editMode ? { paddingTop: '30px' } : undefined}>
        {editMode ? (
          <AutoComplete
            value={awardTypeOption}
            isSearchable={false}
            placeholder="Type"
            className="select-autocomplete"
            options={awardTypeOptions}
            onChange={onAwardChange('type')}
            isClearable={true}
          />
        ) : (
          award.type
        )}
      </TableCell>
      <EditableTableCell
        value={points}
        editMode={editMode}
        onChange={onFieldChange('points')}
        type="text"
        label="Points"
      />
      <EditableTableCell
        value={editMode ? scrip : `$ ${scrip}`}
        editMode={editMode}
        onChange={onFieldChange('scrip')}
        type="text"
        label="Scrip"
        inputAdornment={<DollarInputAdornment />}
      />
      <EditableTableCell
        value={editMode ? cash : `$ ${cash}`}
        editMode={editMode}
        onChange={onFieldChange('cash')}
        type="text"
        label="Cash"
        inputAdornment={<DollarInputAdornment />}
      />

      <TableCell>
        <Grid className="grid" container={true}>
          <Grid
            className="grid-item add-players-card-container note-container"
            item={true}
            xs={12}
            md={editMode ? 12 : 10}
          >
            {editMode ? (
              <Input
                outlined={true}
                fullWidth={true}
                type="text"
                value={note}
                onChange={onFieldChange('note')}
                placeholder="What is this for?"
                label="NOTE"
              />
            ) : (
              award.note
            )}
          </Grid>
          {!editMode && (
            <Grid className="grid-item add-players-card-container" item={true} xs={12} md={2}>
              <Button
                id="reviewScore-editButton"
                color="primary"
                type="submit"
                fullWidth={true}
                onClick={onToggleEditMode}
              >
                <EditIcon />
              </Button>
            </Grid>
          )}
        </Grid>
      </TableCell>
    </TableRow>
  );
};
